<template>
  <div v-if="policyInfo !== null" data-test-level-one>
    <div class="row align-middle">
      <div class="columns shrink">
        <span class="icon icon-large" :class="policyInfo.iconCssClass" />
      </div>
      <div class="columns">
        <strong
          data-test-product-name
          class="policy-level-one-product"
          v-html="policyInfo.productName"
        />
        <div class="show-for-small-only" data-test-description v-html="policyInfo.description" />
        <div
          v-if="policyInfo.policyActiveStatusEnum == 1"
          data-test-future-start-date
          class="show-for-medium color-gray"
          v-html="policyInfo.futurePolicyStartDate"
        />
      </div>
      <div
        class="show-for-medium columns medium-6 large-5"
        data-test-description
        v-html="policyInfo.description"
      />
      <div
        v-if="policyInfo.policyActiveStatusEnum !== 3"
        data-test-level-one-price-row
        class="columns show-for-large"
      >
        <span :data-test-price="policyInfo.price" v-html="policyInfo.priceFormatted" />
        <span data-test-frequency v-html="policyInfo.paymentFrequencyPriceDescription" />
        <span
          class="color-gray policy-level-one-disclaimer"
          data-test-policy-price-disclaimer
          v-html="policyInfo.priceDisclaimer"
        />
        <div class="color-gray" data-test-interval v-html="policyInfo.paymentIntervalText" />
      </div>
    </div>
    <div
      v-if="policyInfo.policyActiveStatusEnum == 1"
      data-test-future-start-date
      class="show-for-small-only small-12 color-gray policy-level-one-date"
      v-html="policyInfo.futurePolicyStartDate"
    />
  </div>
</template>

<script>
export default {
  props: {
    policyInfo: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
